import {createApp} from 'vue'
import eventBadgeGenerator from '../../components/badge/event-badge-generator.vue'

document.addEventListener('DOMContentLoaded', () => {
  const app =  createApp( eventBadgeGenerator )
  app.mount('#event-badge-generator')
})
